module.exports = __webpack_public_path__ + "static/cred_msgold.154e5729.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer/cred_msgold.png
// module id = 1408
// module chunks = 168707334958949